
import { Component, Vue } from 'vue-property-decorator';

import Form1ProcessHeader from "@/components/process/Form1/components/Form1ProcessHeader.vue";
import Form1CaseInformation from "@/components/process/Form1/components/Form1CaseInformation.vue";
import { form1StatusInfoType } from '@/types/Information/Form1';

@Component({
    components:{
        Form1ProcessHeader,
        Form1CaseInformation
    }
})
export default class StartForm1 extends Vue {

    stepsCompleted = {} as form1StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false,
            fourth: false
        }       
    }
}
